import { useContext } from 'react'
import { AuthContext, type AuthContextType } from './authContextValue'

export function useAuth(): AuthContextType {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth deve essere usato dentro AuthProvider')
  }
  return context
}
